import { REPORT, REPORT_TAB_KEYS } from "../actions/types";

const initialState = {
  reports: {},
  error: null,
  isLoading: false,
  activeTaskId: null,
  passwordRequried: false,
  activeTabKey: REPORT_TAB_KEYS.OVERVIEW,
  report: { logs: [], sus: null, testDetails: {}, googleSheetIntegration: {} },
  heatmap: null,
  aiSummary: null,
  integrations: { showDropdown: false, showDrawer: false },
};

const reportReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case REPORT.LOAD:
      // Add Reports in the state
      if (payload?.id) state.reports[payload.id] = payload;

      return { ...state, isLoading: true, report: payload };

    case REPORT.UPDATE:
      return { ...state, isLoading: false, error: null, ...payload };

    case REPORT.RESET:
      return initialState;

    case REPORT.ERROR:
      return { ...state, isLoading: false, error: payload };

    case REPORT.HEATMAP_UPDATE:
      return { ...state, heatmap: payload };

    case REPORT.AI_SUMMARY_UPDATE:
      return { ...state, aiSummary: { ...state?.aiSummary, ...payload } };

    default:
      return state;
  }
};

export default reportReducer;
